export function formatDataShowrooms(data){

  const powerQuantity = parseInt(data?.option?.powerQuantity, 10);
  const options = data?.option || {};

  let countChair = typeof options.chair === 'number' ? options.chair : options.countChair;
  let countTable = typeof options.table === 'number' ? options.table : options.countTable;
  let countFridge = typeof options.fridge === 'number' ? options.fridge : options.countFridge;
  const fridgeLength = options.fridgeLength ? parseFloat(options.fridgeLength) : 0;

  countChair = parseInt(countChair || 0, 10);
  countTable = parseInt(countTable || 0, 10);
  countFridge = parseInt(countFridge || 0, 10);

  let showroomData = {
    "dimension":data.dimension,
    "company":data.company,
    "user":data.user,
    "option":{
      "chair": !Number.isNaN(countChair) ? countChair : 0,
      "table": !Number.isNaN(countTable) ? countTable : 0,
      "fridge": !Number.isNaN(countFridge) ? countFridge : 0,
      fridgeLength: !Number.isNaN(fridgeLength) ? fridgeLength : 0,
      "power": options.power || null,
      "powerQuantity": !Number.isNaN(powerQuantity) ? powerQuantity : 0,
      "standiste":{
        "name":"",
        "phone":"",
        "email":""
      }
    }
  }
  

  if(options.standiste){
    showroomData.option.standiste = {
      name : options.standiste.name ? options.standiste.name : "",
      phone : options.standiste.phone ? options.standiste.phone : "",
      email : options.standiste.email ? options.standiste.email : ""
    }
  }

  return showroomData

}

export function calculPrice(data){
  let obj = {}
  let total = 0

  if(data.option &&
    data.option.direction &&
    data.dimension
  ){
    let dimension = data.dimension
    total = (dimension/6) * 5400
  }

  if(data.option &&
    data.option.customDimension &&
    data.option.customDimension.l &&
    data.option.customDimension.L
  ){
    let dimension = data.option.customDimension.l*data.option.customDimension.L
    // (dimension%6) * 1000 // supplement de 1000€ par 1m
    // (Math.floor(dimension/6))*4500 // supplement de 1000€ par 1m²
    total =  ((Math.floor(dimension/6))*5400) + (dimension%6) * 1000
  }

  obj.totalNoOptions = total
  obj.totalOptions = 0

  if(data.option &&
    data.option.storageSize){
    obj.storagePrice = data.option.storageSize*45
    obj.totalOptions += obj.storagePrice
    total = total + (data.option.storageSize*45)
  }

  if(data.option &&
    data.option.power){
    total = total + 230
    obj.powerPrice = 230
    obj.totalOptions += obj.powerPrice
  }

  if(data.option &&
    data.option.water){
    total = total + 330
    obj.waterPrice = 330
    obj.totalOptions += obj.waterPrice
  }

  obj.total = total
  return obj

}
